import {CHECK_STORE_CLERK}  from "./../../AppConfig";


const initialState={ 
        username:"",
        password:"",
        errorMessage:""
}

export default  function(state=initialState, action){
    switch(action.type){
        case CHECK_STORE_CLERK:        
            return {
                ...state, 
                errorMessage:action.errorMessage, 
                username:action.username,
                password:action.password                
            } 
        default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/loginReducer.js